import { Box, Link, Typography } from '@mui/material';

import { ListingAccordion } from '@modules/_shared/components/ListingAccordion';
import { hasValidProtocol } from '@modules/_shared/utils/urlValidation';
import type { LeadDetailsDrawer } from '@modules/lead-details/type';
import { useLocale } from '@shared/hooks/locale';

type LeadDetailsMarketingCardProps = {
  lead: LeadDetailsDrawer;
};

export const LeadDetailsMarketingCard = ({
  lead,
}: LeadDetailsMarketingCardProps) => {
  const { t } = useLocale();

  const marketingItems = [
    {
      label: t('referrer'),
      value: lead.referrer || '-',
    },
    {
      label: t('referringDomain'),
      value: lead.referring_domain || '-',
    },
    {
      label: t('landingPageUrl'),
      value: lead.landing_page_url || '-',
    },
  ];

  return (
    <ListingAccordion title={t('Marketing')}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {marketingItems.map(({ label, value }) => (
          <Box
            key={label}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 0.5,
            }}
          >
            <Typography
              variant="body2"
              sx={{
                fontWeight: 500,
              }}
            >
              {label}
            </Typography>
            {value && hasValidProtocol(value) ? (
              <Link
                href={value}
                target="_blank"
                rel="noopener noreferrer"
                variant="body2"
                sx={{
                  color: 'text.secondary',
                  wordBreak: 'break-all',
                  overflowWrap: 'anywhere',
                  textDecoration: 'none',
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                }}
              >
                {value}
              </Link>
            ) : (
              <Typography
                variant="body2"
                sx={{
                  color: 'text.secondary',
                  wordBreak: 'break-all',
                  overflowWrap: 'anywhere',
                }}
              >
                {value}
              </Typography>
            )}
          </Box>
        ))}
      </Box>
    </ListingAccordion>
  );
};
